/** Guest silhouette icons from /getroomstatuses (rooms_array.is_vip) and reservation profile */

export const GUEST_ICON_NON_VIP_URL =
    'https://mcusercontent.com/2c3e5bcb748d60e5dc4040a94/images/21cb493a-9611-b106-a12d-cf89405cb72e.png';

export const GUEST_ICON_VIP_URL =
    'https://mcusercontent.com/2c3e5bcb748d60e5dc4040a94/images/dfaf0b24-cc73-b601-d3f0-59a2de43860d.png';

/** rooms_array.occupied from API: 0 or 1 */
export function isRoomOccupied(occupied) {
    return occupied === 1 || occupied === true || occupied === '1';
}

/** rooms_array.is_vip or profile guest_is_vip: 0/1 or boolean */
export function getGuestIconUrl(isVip) {
    const vip = isVip === 1 || isVip === true || isVip === '1';
    return vip ? GUEST_ICON_VIP_URL : GUEST_ICON_NON_VIP_URL;
}
